import { getValidResponseBody, searchApi } from '../../api';

/** Actions' constants */
export const ACTION_SET_DETAILED_RVP = 'ACTION_SET_DETAILED_RVP';
export const ACTION_SET_RVP = 'ACTION_SET_RVP';
export const ACTION_CLEAR_RVP = 'ACTION_CLEAR_RVP';

/** Initial state */
export const INITIAL_STATE = {
  list: [],
  detailedList: [],
};

export const reducer = (currentState = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ACTION_SET_RVP:
      return { ...currentState, list: Array.isArray(payload) ? payload : [] };
    case ACTION_SET_DETAILED_RVP:
      return { ...currentState, detailedList: Array.isArray(payload) ? payload : [] };
    case ACTION_CLEAR_RVP:
      return { ...currentState, list: [], detailedList: [] };
    default:
      return currentState;
  }
};

/** Action (creators) */
export const setRVP = (payload) => ({
  payload,
  type: ACTION_SET_RVP,
});
const setDetailedRVP = (payload) => ({
  payload,
  type: ACTION_SET_DETAILED_RVP,
});
export const clearRVP = () => ({
  type: ACTION_CLEAR_RVP,
});

export const setRVPWithDetailedData = (list, authToken) => async (dispatch) => {
  dispatch(setRVP(list));
  if (!list?.length) {
    dispatch(setDetailedRVP([]));
    return;
  }

  const productIds = list
    .slice()
    .reverse()
    .map((productId) => productId.productId);

  const productsResp = await searchApi.getProductProfile({
    headers: { Authorization: !!authToken ? `Bearer ${authToken}` : undefined },
    method: 'POST',
    body: JSON.stringify({ ids: productIds }),
  });

  const products = getValidResponseBody(productsResp) || [];

  dispatch(setDetailedRVP(products));
};
